import { Button } from 'antd';
import { useAuthSession } from '@modeling/account';

export function LoginPage() {
  const session = useAuthSession();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#001529',
        color: 'white',
      }}
    >
      <h1 style={{ marginBottom: 24, color: 'white', fontSize: 32 }}>DC Admin</h1>
      <p style={{ marginBottom: 32, opacity: 0.75 }}>租户与 Schema Profile 管理平台</p>
      <Button type="primary" size="large" onClick={() => session.login()}>
        登录
      </Button>
    </div>
  );
}
